<template>
  <div>
    <v-skeleton-loader v-if="!list" type="article"></v-skeleton-loader>
    <v-container fluid class="pt-10" v-if="list">
      <h2 class="text-h5 mb-5 mt-0">
        <v-btn
          color="light-blue"
          small
          class="mr-2"
          dark
          fab
          to="/dashboard/messages"
          ><v-icon small>mdi-arrow-expand-left</v-icon></v-btn
        >{{ list.topic }}
      </h2>
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <v-list three-line v-if="messages">
          <template v-for="item in decMessages">
            <v-list-item :key="item.id">
              <v-avatar
                v-if="item.user && $store.state.user.profilePic"
                size="50"
              >
                <img
                  :src="$store.state.baseUrl + $store.state.user.profilePic"
                />
              </v-avatar>
              <v-avatar
                v-if="item.user && !$store.state.user.profilePic"
                color="light-blue"
                size="50"
              >
                <span class="white--text">ND</span>
              </v-avatar>
              <v-sheet
                class="ml-3 mr-3 pl-5 pr-5"
                width="100%"
                rounded
                color="grey lighten-3"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.sender }}</v-list-item-title>
                  <v-list-item-subtitle
                    >{{ item.message }} -
                    {{ getDateFormat(item.dateCreated) }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-sheet>
              <v-avatar v-if="!item.user" color="grey" size="50">
                <span class="white--text">AD</span>
              </v-avatar>
            </v-list-item>
          </template>
        </v-list>
      </vue-custom-scrollbar>
      <v-row no-gutters class="pt-10">
        <v-col cols="10">
          <v-text-field
            full-width
            outlined
            type="text"
            v-model="message"
            v-bind:label="$t('Writemessage')"
            append-icon="mdi-send"
            v-on:keyup.enter="sendMessage"
            @click:append="sendMessage"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import AuthService from "@/services/AuthService";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { format } from "date-fns";

export default {
  name: "MessageViewComponent",
  mixins: [timeoutMixin],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      format,
      parm: this.$route.params.id,
      error: null,
      list: null,
      messages: [],
      valid: null,
      message: "",
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      }
    };
  },
  computed: {
    decMessages() {
      return this.messages.slice().reverse();
    }
  },
  created() {
    AuthService.getMessageTopic({
      id: this.parm
    })
      .then(result => {
        this.list = result.data.topic;
        this.messages = result.data.topic.messages;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    getDateFormat(x) {
      return this.format(new Date(x), "HH:mm MM/dd/yyyy");
    },
    sendMessage() {
      if (this.message.trim()) {
        AuthService.addMessage({
          topic: this.parm,
          message: this.message
        })
          .then(result => {
            this.message = "";
            this.list = result.data.topic;
            this.messages = result.data.topic.messages;
          })
          .catch(err => {
            this.error = err.response.data.error;
          });
      }
    }
  }
};
</script>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 400px);
}
</style>
